import LandingPage from '../components/LandingPage'
import Section from '../containers/Section'
import Dashboard from '../components/Dashboard'
import Faq from '../components/Faq'

const appRoutes = [
  { path: '/index/', name: 'Index', component: LandingPage },
  { path: '/edit/:id', name: 'Section', component: Section },
  { path: '/dashboard/', name: 'Dashboard', component: Dashboard },
  { path: '/faq/', name: 'Faq', component: Faq },
  { redirect: true, path: '/', to: '/index', name: 'Index' },
]

export default appRoutes
